import { gql } from 'apollo-boost'

const MENU_DOCUMENT_FILE_URL = gql`
  query menuDocumentFileUrl($fileBucketName: String!, $fileKey: String!) {
    menuDocumentFileUrl(fileBucketName: $fileBucketName, fileKey: $fileKey)
  }
`

export default MENU_DOCUMENT_FILE_URL
